export default class Toast {
  constructor() {
    this.toast = document.querySelector('.js-toast');

    if (!this.toast) {
      this.toast = document.createElement('div');
      this.toast.className = 'toast toast--Hidden js-toast';
      document.body.appendChild(this.toast);
    }
  }

  show(message, type = 'info', duration = 3000) {
    this.toast.textContent = message;
    this.toast.className = `toast toast--${type} toast--Visible js-toast`;

    setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide() {
    this.toast.className = 'toast toast--Hidden js-toast';
  }
}
